const TOP_OFFSET = 48;
const SCROLL_DURATION = 350;

const getScrollableParent = (element: HTMLElement): HTMLElement | null => {
  let parent = element.parentElement;
  while (parent) {
    const { overflowY } = getComputedStyle(parent);
    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      parent.scrollHeight > parent.clientHeight
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
};

const easeInOutQuad = (t: number) => (t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2);

const prefersReducedMotion = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;

const animateScrollTop = (container: HTMLElement, targetTop: number) => {
  const startTop = container.scrollTop;
  const distance = targetTop - startTop;
  if (distance === 0) return;

  if (prefersReducedMotion()) {
    container.scrollTop = targetTop;
    return;
  }

  let startTime: number | null = null;
  const step = (time: number) => {
    if (startTime === null) startTime = time;
    const progress = Math.min((time - startTime) / SCROLL_DURATION, 1);
    container.scrollTop = startTop + distance * easeInOutQuad(progress);
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

export const scrollToElement = (element: HTMLElement | null) => {
  if (!element) return;

  const container = getScrollableParent(element);
  if (container) {
    const targetTop =
      container.scrollTop +
      element.getBoundingClientRect().top -
      container.getBoundingClientRect().top -
      TOP_OFFSET;
    animateScrollTop(container, Math.max(targetTop, 0));
    return;
  }

  const top =
    element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - TOP_OFFSET;
  window.scrollTo({ behavior: "smooth", top });
};
